import { getData, postData } from "@/utils/http";
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		orgId:"",
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, tableLoading) {
			state.addLoading = tableLoading;
		},
		CHANGE_TABLE_DATA(state, list) {
			state.tableList = list;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
				state[changeData["changeKey"]] = [changeData["data"]];
			} else {
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
	},
	actions: {
		//获取列表
		getList({ commit, state },deptId) {
			return new Promise((resolve) => {
				getData(`supervise/sys/role/list?page=1&size=9999&deptId=${state.orgId?state.orgId[state.orgId.length-1]:state.orgId}`).then((res) => {
					if (res.state == 1) {
						commit("CHANGE_TABLE_DATA", res.data.rows);
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//添加
		add({ commit }, addData) {
			return new Promise((resolve) => {

				postData(`supervise/sys/role/save`, addData).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},


		//获取未添加权限
		getPowerAddList({ commit }) {
			return new Promise((resolve) => {
				getData(`supervise/sys/menu/tree`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//获取角色绑定的菜单
		getOneRole({ commit, state }) {
			return new Promise((resolve) => {
				getData(`supervise/sys/role/menu/${state.activeItem.id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//删除
		remove({ commit, state }) {
			return new Promise((resolve) => {
				getData(`supervise/sys/role/delete?id=${state.activeItem.id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},



		//获取部门列表
        getOrganizationList({commit,state}){
            return new Promise((resolve)=>{
                getData(`supervise/sys/dept/tree`).then((res)=>{
					if(res.state==1){
                        resolve({
                            state:1,
							data:res.data,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
							data:[],
                            msg:res.msg
                        });
                    }
                })
            })
		},


		//写入当前操作t条目
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},

		//修改loading
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value);
		},

		changeListLoading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value)
		},
		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit("CHANGE_SEARCH_COLL", changeData)
		},



	}
}
